<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Edit Emergency Contact

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px">
        <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
          <div class="modal-body padding-top-0px">








            <div class="row margin-left-auto">
              <div class="col-md-12 padding-l-0px">

                <!--<div class="card-header wh-header card-header-bg padding-left-7px padding-top-6px margin-top-10">
                  Emergency Contact(Family)


                </div>-->

                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right">
                        <label for="diaplayName"><span>*</span> Relationship</label>
                      </div>

                      <div class="col-md-4">
                        <!--<CodeTypeValue CodeType="RELTP"
                             id="CurrentActorEditEmergencyInfoRequest.RelationType"
                         [(ngModel)]="CurrentActorEditEmergencyInfoRequest.RelationType" SelectedValue="{{CurrentActorEditEmergencyInfoRequest.RelationType}}"
                        name="CurrentActorEditEmergencyInfoRequest.RelationType">
                         </CodeTypeValue>-->
                        <label>{{CurrentActorEditEmergencyInfoRequest.RelationType}}</label>
                        <!--<input type="text" class="form-control" id="CurrentActorEditEmergencyInfoRequest.RelationType"
                               [(ngModel)]="CurrentActorEditEmergencyInfoRequest.RelationType"
                               name="CurrentActorEditEmergencyInfoRequest.RelationType"
                               placeholder="Relation Name" maxlength="20" minlength="1" #RelationType="ngModel" pattern="^[\sa-zA-Z0-9,/._\-?]*$">
                        <small class="form-text text-danger"
                               *ngIf="(!RelationType.valid && (RelationType.dirty || RelationType.touched) && RelationType.errors.required)">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!RelationType.valid && RelationType.errors.pattern)">(special characters are not allowed)</small>-->

                      </div>
                    </div>


                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right">
                        <label for="firstName"> Name</label>
                      </div>
                      <div class="col-md-4">

                        <input type="text" class="form-control" placeholder="Name"
                               id="CurrentActorEditEmergencyInfoRequest.EmergencyContactPersonName"
                               [(ngModel)]="CurrentActorEditEmergencyInfoRequest.EmergencyContactPersonName"
                               name="CurrentActorEditEmergencyInfoRequest.EmergencyContactPersonName" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                               maxlength="20" minlength="1" #EmergencyContactPersonName="ngModel" required>
                        <small class="form-text text-danger"
                               *ngIf="(!EmergencyContactPersonName.valid && (EmergencyContactPersonName.dirty || EmergencyContactPersonName.touched) && EmergencyContactPersonName.errors.required )">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!EmergencyContactPersonName.valid && EmergencyContactPersonName.errors.pattern)">(special characters are not allowed)</small>


                      </div>

                    </div>

                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right padding-left-0px">
                        <label for="diaplayName" class="margin-bottom-0px margin-top-5px"><span>*</span> Mobile Phone </label>
                      </div>
                      <div class="col-md-4">
                        <input type="tel" class="form-control" id="CurrentActorEditEmergencyInfoRequest.EmergencyContactNo1"
                               [(ngModel)]="CurrentActorEditEmergencyInfoRequest.EmergencyContactNo1"
                               mask="(000) 000-0000"
                               name="CurrentActorEditEmergencyInfoRequest.EmergencyContactNo1" pattern="[0-9]{10}" #EmergencyContactNo1="ngModel"
                               placeholder="Mobile Phone" />
                        <small class="form-text text-danger"
                               *ngIf="(!EmergencyContactNo1.valid)">(Provide Valid CellNo)</small>
                      </div>
                    </div>


                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right ">
                        <label for="diaplayName">City </label>
                      </div>
                      <div class="col-md-4 ">
                        <!--<CodeTypeValue CodeType="MARTL"></CodeTypeValue>-->
                        <!--id="CurrentActorPersonalDetailInfoRequest.City"
                               [(ngModel)]="CurrentActorPersonalDetailInfoRequest.City"
                               name="CurrentActorPersonalDetailInfoRequest.City"
                                maxlength="50" pattern="^[\sa-zA-Z0-9,._\-?]*$" #City="ngModel" />
                        <small class="form-text text-danger"
                               *ngIf="(!City.valid && City.errors.pattern)">(special characters are not allowed)</small>-->
                        <!--<label>Hyderabad</label>-->
                        <input type="text" class="form-control" id="CurrentActorEditEmergencyInfoRequest.EmergencyAddress"
                               [(ngModel)]="CurrentActorEditEmergencyInfoRequest.EmergencyAddress"
                               name="CurrentActorEditEmergencyInfoRequest.EmergencyAddress"
                               placeholder="City" maxlength="20" minlength="1" #EmergencyAddress="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$">
                        <small class="form-text text-danger"
                               *ngIf="(!EmergencyAddress.valid && (EmergencyAddress.dirty || EmergencyAddress.touched) && EmergencyAddress.errors.required)">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!EmergencyAddress.valid && EmergencyAddress.errors.pattern)">(special characters are not allowed)</small>
                      </div>
                    </div>


                  </div>
                </div>

                <!--<div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right ">
                        <label for="diaplayName">Image </label>
                      </div>
                      <div class="col-md-3 ">
                        <input type="file" name="pic" accept="image/*">


                      </div>
                    </div>


                  </div>
                </div>-->


              </div>
            </div>


            <!--<div class="card-footer text-align-center">
              <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto" (click)="activeModal.close('Close click')">Close</button>
            </div>-->


















          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
            <button type="submit" [disabled]="!f.valid" class="btn actions-btn-prime float-right font-size-13px margin-right-auto">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
